var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_519",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29230",
    "data-name": "Group 29230",
    transform: "translate(657 10673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -657, -10673)",
    filter: "url(#Ellipse_519)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_519-2",
    "data-name": "Ellipse 519",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50310",
    "data-name": "Path 50310",
    d: "M26.03,299.278l-4.64-3.65a.566.566,0,0,1-.184-.748,2.976,2.976,0,0,1,3.584-.92l4.2,2.381-2.956,2.937Zm1.557,1.557,3.659,4.65a.566.566,0,0,0,.748.184l.277-.191a2.517,2.517,0,0,0,.778-3.032l-2.515-4.558Z",
    transform: "translate(-655.951 -10930.924)",
    fill: "#ff2c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50311",
    "data-name": "Path 50311",
    d: "M65.51,311.655l-2.625,2.608,2.355,1.852,2.956-2.937Z",
    transform: "translate(-695.161 -10947.762)",
    fill: "#e62753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50312",
    "data-name": "Path 50312",
    d: "M114.882,60.107a1.606,1.606,0,0,1-.108-2.15c.745-.914,1.678-1.931,2.237-2.491a5.61,5.61,0,0,1,1.651-1.176.305.305,0,0,1,.376.044l1.618,1.618a.306.306,0,0,1,.044.376,5.61,5.61,0,0,1-1.176,1.65c-.56.56-1.577,1.493-2.491,2.237A1.606,1.606,0,0,1,114.882,60.107Zm14.6,14.6a1.606,1.606,0,0,1-.108-2.15c.745-.914,1.678-1.931,2.237-2.491a5.609,5.609,0,0,1,1.651-1.176.305.305,0,0,1,.376.044l1.618,1.618a.306.306,0,0,1,.044.376,5.61,5.61,0,0,1-1.176,1.651c-.56.56-1.577,1.493-2.491,2.237A1.606,1.606,0,0,1,129.486,74.711Z",
    transform: "translate(-743.545 -10706.048)",
    fill: "#c3d3db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50313",
    "data-name": "Path 50313",
    d: "M14.752,66.313l5.725-5.725L2.743,55.016a1,1,0,0,0-.97.237l-1.5,1.5a1.17,1.17,0,0,0,.422,1.8l14.056,7.76Z",
    transform: "translate(-636.111 -10706.737)",
    fill: "#ff2c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50314",
    "data-name": "Path 50314",
    d: "M191.389,126.308l-5.111,5.111,3.393,1.873,5.725-5.725Z",
    transform: "translate(-811.029 -10773.717)",
    fill: "#e62753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50315",
    "data-name": "Path 50315",
    d: "M271.16,181.917l5.725-5.725,5.572,17.735a1,1,0,0,1-.237.97l-1.5,1.5a1.17,1.17,0,0,1-1.8-.422Z",
    transform: "translate(-890.736 -10820.559)",
    fill: "#ff2c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50316",
    "data-name": "Path 50316",
    d: "M97.8,8.337l-9.618,9.618a52.13,52.13,0,0,1-5.126,4.5l-4.576,3.51c-1.059.813-2.319.911-3,.234s-.579-1.937.234-3l3.51-4.576a52.134,52.134,0,0,1,4.5-5.126L93.347,3.88A15.973,15.973,0,0,1,97.767.718C99.141.07,100.6-.336,101.31.374s.3,2.169-.344,3.543A15.97,15.97,0,0,1,97.8,8.337Z",
    transform: "translate(-706.574 -10655.11)",
    fill: "#e0f3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50317",
    "data-name": "Path 50317",
    d: "M101.6.4A1.407,1.407,0,0,0,100.6.025,6.094,6.094,0,0,1,99.888,2.6a15.971,15.971,0,0,1-3.162,4.42l-9.618,9.618a52.123,52.123,0,0,1-5.126,4.5l-4.576,3.51a2.923,2.923,0,0,1-2.063.667,1.553,1.553,0,0,0,.43.906c.677.677,1.937.579,3-.234l4.576-3.51a52.133,52.133,0,0,0,5.126-4.5L98.089,8.36a15.973,15.973,0,0,0,3.162-4.42C101.9,2.567,102.3,1.106,101.6.4Z",
    transform: "translate(-706.859 -10655.134)",
    fill: "#c3d3db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50318",
    "data-name": "Path 50318",
    d: "M403.544,50.659l-.328.328c-.3.305-3.717-3.107-3.412-3.412l.328-.328a.69.69,0,0,1,.758-.163,5.622,5.622,0,0,1,2.816,2.816A.69.69,0,0,1,403.544,50.659Z",
    transform: "translate(-1011.516 -10699.274)",
    fill: "#51c4f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50319",
    "data-name": "Path 50319",
    d: "M92.4,344.475a.457.457,0,0,1-.323-.781l3.994-3.994a.457.457,0,0,1,.647.647l-3.994,3.994A.456.456,0,0,1,92.4,344.475Z",
    transform: "translate(-722.444 -10973.972)",
    fill: "#e62753"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.87c4d3e0d88fe2fc8d3f64e005c4991e.svg";
export { ForwardRef as ReactComponent };